// ── "Somo la Maisha" — Life Lesson Reflections ─────────────────────────
// The unique feature: after every game, a short reflection connects what
// happened on the board to a life skill — patience, planning, resilience,
// humility, honesty in effort — echoing Iyanna Foundation's character
// education mission. Nothing like this exists on chess.com.

const WIN_LESSONS = [
  {
    swahili: 'Ushindi mzuri huja kwa mipango, sio bahati.',
    english: 'A good win comes from planning, not luck.',
    skill: 'Mipango (Planning)',
  },
  {
    swahili: 'Uliona fursa na ukaitumia — hivyo ndivyo maisha yanavyoshindwa.',
    english: 'You saw an opportunity and used it — that\'s how life is won too.',
    skill: 'Ujasiri (Courage)',
  },
  {
    swahili: 'Kila hatua uliyopiga ilikuwa na sababu. Endelea kufikiri kabla ya kutenda.',
    english: 'Every move you made had a reason. Keep thinking before you act.',
    skill: 'Uangalifu (Thoughtfulness)',
  },
];

const LOSS_LESSONS = [
  {
    swahili: 'Kushindwa si mwisho — ni somo. Wapiga chess wakubwa wote wamewahi kupoteza.',
    english: 'Losing isn\'t the end — it\'s a lesson. Every great player has lost before.',
    skill: 'Uvumilivu (Resilience)',
  },
  {
    swahili: 'Angalia ni wapi ulipokosea, kisha jaribu tena. Hivyo ndivyo tunavyokua.',
    english: 'Look at where you went wrong, then try again. That\'s how we grow.',
    skill: 'Kujitathmini (Self-reflection)',
  },
  {
    swahili: 'Kukubali kushindwa kwa heshima ni ushindi wa tabia.',
    english: 'Accepting a loss with grace is a victory of character.',
    skill: 'Unyenyekevu (Humility)',
  },
];

const DRAW_LESSONS = [
  {
    swahili: 'Wakati mwingine kusimama sawa na mwenzako ni matokeo mazuri pia.',
    english: 'Sometimes standing equal with your opponent is a good outcome too.',
    skill: 'Uwiano (Balance)',
  },
  {
    swahili: 'Mliona nguvu za kila mmoja na mkaheshimiana — hilo ni somo la ushirikiano.',
    english: 'You both recognized each other\'s strength and respected it — a lesson in cooperation.',
    skill: 'Heshima (Respect)',
  },
];

const RESIGNATION_LESSONS = [
  {
    swahili: 'Kujua wakati wa kuacha ni hekima, si udhaifu.',
    english: 'Knowing when to step back is wisdom, not weakness.',
    skill: 'Hekima (Wisdom)',
  },
];

const TIMEOUT_LESSONS = [
  {
    swahili: 'Muda ni rasilimali — panga vizuri jinsi unavyoutumia, ubaoni na maishani.',
    english: 'Time is a resource — plan how you use it, on the board and in life.',
    skill: 'Usimamizi wa Muda (Time Management)',
  },
];

function pickRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

/**
 * Get a life-lesson reflection for a finished game.
 * @param {'white'|'black'|'draw'} winner
 * @param {string} playerColor - 'white' | 'black' | null (spectator)
 * @param {string} reason - 'checkmate' | 'resignation' | 'timeout' | 'stalemate' | 'draw'
 */
export function getLifeLesson(winner, playerColor, reason) {
  if (winner === 'draw') return pickRandom(DRAW_LESSONS);
  if (reason === 'resignation') return pickRandom(RESIGNATION_LESSONS);
  if (reason === 'timeout') return pickRandom(TIMEOUT_LESSONS);

  const won = playerColor && winner === playerColor;
  if (playerColor == null) {
    // Spectator — neutral framing
    return pickRandom(WIN_LESSONS);
  }
  return won ? pickRandom(WIN_LESSONS) : pickRandom(LOSS_LESSONS);
}
